<template>
  <div id="connection-brief">
    <div class="contents">
      <div class="column">
        <div class="profile-container">
          <div class="photo" :style="updatePartnerPhotoView()"></div>
          <div class="name">
            <span>{{ userName }}</span
            >{{ userType }}
          </div>
        </div>
        <div class="relationship" v-if="relDefined" :class="`${typeColor}`">
          <span>As Your</span>
          <div class="select disable">{{ userType }}</div>
          <div class="pov mine">
            <div class="pov-container">
              In your view,<br />
              <span>{{ userName }}</span> is <span>{{ myMatchingRate }}</span
              >% compatible with you.
            </div>
          </div>
          <div class="pov yours">
            <div class="pov-container">
              In <span>{{ userName }}</span
              >'s view<br />
              You are <span>{{ partnerMatchingRate }}</span
              >% compatible with <span>{{ userName }}</span
              >.
            </div>
          </div>
        </div>
        <div class="relationship" v-else>
          <span>Define the relationship</span>
          <div class="select">Choose</div>
        </div>
        <div class="button-group" v-if="isMobile">
          <div class="button" @click="seeDetail">See Detail</div>
        </div>
      </div>
      <div v-if="!isMobile" id="detail-in-brief">
        <div class="column">
          <div class="contents-container">
            <div class="contents">
              <div class="container">
                <div class="profile-container">
                  <div class="photo" :style="updateMyPhotoView()"></div>
                  <div
                    class="photo char"
                    :style="updatePartnerPhotoView()"
                  ></div>
                  <div class="name">{{ userName }}</div>
                  <div class="type" :class="`${typeColor}`">{{ userType }}</div>
                </div>
                <div class="desc">{{ content }}</div>
              </div>
            </div>
            <div class="padding-area"></div>
          </div>
        </div>
        <div class="column" v-for="(item, index) in detailList" :key="index">
          <div class="contents-container">
            <div class="contents">
              <div class="container">
                <h4 class="custom-for-connections">{{ item.title }}</h4>
                <div class="ind">
                  <div class="profile-wrapper">
                    <div
                      class="profile profile-left"
                      :style="{ left: item.myPosition + '0%' }"
                    >
                      <div class="photo" :style="updateMyPhotoView()"></div>
                      <div class="score">{{ item.myPosition }}</div>
                    </div>
                  </div>
                  <div class="bar">
                    <div
                      class="inbetween"
                      :style="{
                        'margin-left': getInbetweenMin(item) + '0%',
                        'margin-right': 10 - getInbetweenMax(item) + '0%'
                      }"
                    >
                      <div class="start"></div>
                      <div class="end"></div>
                    </div>
                  </div>
                  <div class="profile-wrapper">
                    <div
                      class="profile profile-right"
                      :style="{
                        right: 10 - item.partnerPosition + '0%'
                      }"
                    >
                      <div class="score">{{ item.partnerPosition }}</div>
                      <div
                        class="photo"
                        :style="updatePartnerPhotoView()"
                      ></div>
                    </div>
                  </div>
                  <div class="extra">
                    <span>{{ getLabelItem(item.labels, 0) }}</span>
                    <span>{{ getLabelItem(item.labels, 1) }}</span>
                  </div>
                </div>
                <div class="desc">{{ item.description }}</div>
              </div>
            </div>
            <div class="padding-area"></div>
          </div>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import CompLoading from '@/components/CompLoading.vue'
import ConnectionService from '@/services/connection-service'

export default {
  name: 'ConnectionShare',
  mixins: [common],
  components: {
    CompLoading
  },
  data() {
    return {
      isLoading: false,

      myName: '',
      userName: 'User Name',
      userType: 'User Type',
      relDefined: true,
      partnerName: '',
      partnerImg: '',
      myMatchingRate: '',
      partnerMatchingRate: '',
      partnerType: '',
      connectionCode: this.$route.params.code,
      myImage: '',
      partnerImage: '',
      typeColor: '',
      content: '',
      detailList: [],

      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  created() {
    this.$parent.setHeader('Connection Summary')
    this.$parent.headerBack = false
    this.$parent.setNav(false)
    this.$parent.setBottomTab(false)
    this.$parent.setHeaderShare(false)

    const shareCode = this.$route.params.code
    if (this.isEmpty(shareCode)) {
      this.goBack()
    } else {
      this.getConnectionDetail(shareCode)
    }
    // this.performGetUserInfo()
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    }
  },
  methods: {
    getInbetweenMin(item) {
      if (
        this.isEmpty(item) ||
        this.isEmpty(item.myPosition) ||
        this.isEmpty(item.partnerPosition)
      ) {
        return 0
      }

      const myPos = item.myPosition
      const partnerPos = item.partnerPosition
      return myPos > partnerPos ? partnerPos : myPos
    },
    getInbetweenMax(item) {
      if (
        this.isEmpty(item) ||
        this.isEmpty(item.myPosition) ||
        this.isEmpty(item.partnerPosition)
      ) {
        return 0
      }

      const myPos = item.myPosition
      const partnerPos = item.partnerPosition
      return myPos > partnerPos ? myPos : partnerPos
    },
    getLabelItem(label, idx) {
      if (this.isEmpty(label)) return

      const labels = label.split('-')
      if (labels && labels.length > idx) return labels[idx]
      return 'Unknown'
    },
    // performGetUserInfo() {
    //   UserService.getUserInfo().then(({ resultCode, resultData }) => {
    //     if (resultCode === 0) {
    //       this.myName = `${resultData.firstName} ${resultData.lastName}`
    //     }
    //   })
    // },
    getConnectionDetail(code) {
      ConnectionService.getShareConnBrief(code).then(
        ({ resultCode, resultData }) => {
          if (!this.isMobile) this.isLoading = false

          if (resultCode === 0) {
            this.userName = resultData.partnerName
            this.userType = resultData.type
            this.myMatchingRate = resultData.myMatchingRate
            this.partnerMatchingRate = resultData.partnerMatchingRate
            this.myImage = resultData.myImage
            this.partnerImage = resultData.partnerImage
            if (this.userType === 'Peer') {
              this.typeColor = 'type-1'
            } else if (this.userType === 'Coworker') {
              this.typeColor = 'type-2'
            } else if (this.userType === 'Employee') {
              this.typeColor = 'type-3'
            } else if (this.userType === 'Supervisor') {
              this.typeColor = 'type-4'
            }

            this.content = resultData.content1 + ' ' + resultData.content2
            this.detailList.push(resultData.sec1)
            this.detailList.push(resultData.sec2)
            this.detailList.push(resultData.sec3)
            this.detailList.push(resultData.sec4)
            this.detailList.push(resultData.sec5)
            this.detailList.push(resultData.sec6)
            this.detailList.push(resultData.sec7)
            this.detailList.push(resultData.sec8)
          }
        }
      )
    },
    seeDetail() {
      this.goPage(`share/connection_more/${this.connectionCode}`)
    },
    updatePartnerPhotoView() {
      return {
        backgroundImage: `url(data:image/png;base64,${this.partnerImage})`
      }
    },
    updateMyPhotoView() {
      return {
        backgroundImage: `url(data:image/png;base64,${this.myImage})`
      }
    }
  }
}
</script>

<style lang="scss" src="@/scss/connections.scss" scoped></style>
